import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, IconButton, Stack, TableCell, Typography } from '@mui/material';

interface Props {
  readonly colSpan: number;
  readonly label: string;
  readonly rowCount: number;
  readonly isExpanded: boolean;
  readonly onToggleExpansion: () => void;
  readonly children?: React.ReactNode;
}

export function PriceGridGroupRow({ colSpan, label, rowCount, isExpanded, onToggleExpansion, children }: Props) {
  return (
    <TableCell
      colSpan={colSpan}
      sx={{
        bgcolor: 'action.hover',
        borderTop: 1,
        borderColor: 'divider',
        py: 1,
      }}
    >
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        sx={{
          alignItems: { xs: 'stretch', lg: 'center' },
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box sx={{ minWidth: 0, display: 'flex', alignItems: 'center', flex: '1 1 320px' }}>
          <IconButton
            size="small"
            onClick={onToggleExpansion}
            title={isExpanded ? 'Collapse group' : 'Expand group'}
            sx={{ mr: 1 }}
          >
            {isExpanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
          </IconButton>
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ fontWeight: 'bold' }}>
              {label}
            </Typography>
            <Typography color="text.secondary" variant="body2">
              {rowCount} filtered {rowCount === 1 ? 'price' : 'prices'}
            </Typography>
          </Box>
        </Box>
        {children}
      </Stack>
    </TableCell>
  );
}
